<template>
    <div class="english" @dragover="()=>isActive = true" @dragleave="()=>isActive = false">
      <!--UPLOAD-->
      <form enctype="multipart/form-data" novalidate v-if="isInitial || isSaving">
        <div class="dropbox" v-bind:class="{ active: isActive }">
          <!-- :accept="acceptedFileTypes ? acceptedFileTypes : 'application/pdf, application/zip'" -->
          <input type="file" multiple :name="uploadFieldName" :disabled="isSaving" @click="clickedButton"
          @change="filesChange($event.target.name, $event.target.files); fileCount = $event.target.files.length" :accept="acceptedFileTypes"
             class="input-file" v-bind="captureAttrs">
            <p v-if="isInitial">
              Drag your file(s) here to upload<br> or click to choose from your pc
            </p>
            <p v-if="isSaving">
              Uploading {{ fileCount }} files...
            </p>
        </div>
      </form>
      <!--SUCCESS-->
      <div v-if="isSuccess">
        <span>Uploaded {{ uploadedFiles.length }} file(s) successfully.</span>
        <p>
          <a href="javascript:void(0)" @click="reset()">Change uploaded file</a>
        </p>
        <!-- <ul class="list-unstyled">
          <li v-for="item in uploadedFiles">
            <img :src="item.url" class="img-responsive img-thumbnail" :alt="item.originalName">
          </li>
        </ul> -->
      </div>
      <!--FAILED-->
      <div v-if="isFailed">
        <span>Uploaded failed.</span>
        <p>
          <a href="javascript:void(0)" @click="reset()">Try again</a>
        </p>
        <pre>{{ uploadError }}</pre>
      </div>
    </div>

</template>

<script>
import { upload } from './file-share-upload-service';

  const STATUS_INITIAL = 0, STATUS_SAVING = 1, STATUS_SUCCESS = 2, STATUS_FAILED = 3;

  export default {
    name: 'file-upload',
    data() {
      return {
        uploadedFiles: [],
        uploadError: null,
        currentStatus: null,
        uploadFieldName: 'file',
        isActive : false,
      }
    },
    props:{
      maxUploads: {
        required: false,
      },
      path: {
        required: false,
        default: '/upload'
      },
      moreDetails: {
        required: false
      },
      acceptedFileTypes: {
        required: false,
        default: 'application/pdf',
      },
      capture: {
        type: [Boolean, String],
        default: null
      }
    },
    watch: {
      uploadedFiles :function(){

      }
    },
    computed: {
      isInitial() {
        return this.currentStatus === STATUS_INITIAL;
      },
      isSaving() {
        return this.currentStatus === STATUS_SAVING;
      },
      isSuccess() {
        return this.currentStatus === STATUS_SUCCESS;
      },
      isFailed() {
        return this.currentStatus === STATUS_FAILED;
      },
      captureAttrs() {
        // Only apply capture if prop is passed
        if (this.capture === null) return {}

        // allow: true | "environment" | "user"
        if (this.capture === true) return { capture: '' }

        return { capture: this.capture }
      }
      // uploadsMaxxed() {
      //   if(this.maxUploads){
      //     if(this.uploadedFiles.length == this.maxUploads){
      //       return true;
      //     }
      //   }
      // }
    },
    methods: {
      clickedButton() {
        // console.log('clicked')
      },

      reset() {
        // reset form to initial state
        this.currentStatus = STATUS_INITIAL;
        this.uploadedFiles = [];
        this.uploadError = null;
      },
      save(formData) {
        // upload data to the server
        this.currentStatus = STATUS_SAVING;
 

    
        this.moreDetails? formData.append('folder_name', this.moreDetails.path) : null;

        upload(formData, this.path)
        //   .then(wait(1500)) // DEV ONLY: wait for 1.5s
          .then(files => {
              console.log(files);
            this.$emit('uploaded', files.data)
            this.currentStatus = STATUS_SUCCESS;
            this.uploadedFiles = [].concat(files.data.data);
            // this.currentStatus = STATUS_SUCCESS;

          })
          .catch(error => {
            this.uploadError = error.response;
            this.currentStatus = STATUS_FAILED;
            this.$emit('error', error)
          });
      },
      filesChange(fieldName, fileList) {
        // handle file changes
        const formData = new FormData();

        if (!fileList.length) return;

        // append the files to FormData
        Array
          .from(Array(fileList.length).keys())
          .map(x => {
            formData.append(fieldName, fileList[x], fileList[x].name);
          });

        // save it
        this.save(formData);
      }
    },
    mounted() {
    // console.log(this.maxUploads)
      this.reset();
    },
  }

</script>

<style lang="scss" scoped>
  .dropbox {
    outline: 2px dashed grey; /* the dash box */
    outline-offset: -10px;
    background: #d0a6a6;
    color: dimgray;
    padding: 10px 10px;
    min-height: 100px; /* minimum height */
    position: relative;
    cursor: pointer;
    padding: 20px;

  }

  .input-file {
    top: 0px;
    right: 0px;
    opacity: 0; /* invisible but it's there! */
    width: 100%;
    position: absolute;
    cursor: pointer;
    height: 110px;
    background-color: red;
  }

  .dropbox:hover, .active {
    background: lightblue; /* when mouse over to the drop zone, change color */
  }

  .dropbox p {
    font-size: 0.9em;
    text-align: center;
    margin: 1rem;
  }

  .uploadsMaxxed{
    display:none;
  }
</style>
